import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthContext'
import { ProtectedRoute } from '@/auth/ProtectedRoute'
import { LoginView } from '@/auth/LoginView'
import { TenantProvider } from '@/tenant/TenantProvider'
import { ThemeProvider } from '@/theme/ThemeProvider'
import { AspectFrame } from '@/components/layout/AspectFrame'
import { DashboardShell } from '@/components/layout/DashboardShell'
import { ViewSwitcher } from '@/components/views/ViewSwitcher'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { DataPipe } from '@/data/DataServiceContext'
import { MilestoneDetector } from '@/milestones/MilestoneDetector'
import { CelebrationOverlay } from '@/components/celebration/CelebrationOverlay'
import { SoundEffects } from '@/components/celebration/SoundEffects'
import { AudioUnlockGate } from '@/components/controls/AudioUnlockGate'
import { SettingsOverlay } from '@/components/settings/SettingsOverlay'
import { DevPanel } from '@/dev/DevPanel'
import { TakeoverScheduler } from '@/components/views/TakeoverScheduler'
import { isProd } from '@/lib/env'

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <AspectFrame>
              <Routes>
                <Route path="/login" element={<LoginView />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <TenantProvider>
                        <DataPipe>
                          <MilestoneDetector />
                          <SoundEffects />
                          <TakeoverScheduler />
                          <DashboardShell>
                            <ViewSwitcher />
                          </DashboardShell>
                          <CelebrationOverlay />
                          <AudioUnlockGate />
                          <SettingsOverlay />
                          {!isProd && <DevPanel />}
                        </DataPipe>
                      </TenantProvider>
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AspectFrame>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
